var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBimifyDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 638,
    height: 211,
    viewBox: "0 0 638 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_298_1527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.761 0H0V163.568H113.761V139.86H25.7676V92.513H113.761V68.7589H25.7676V23.7158H113.761V68.7589H137.435V23.7081H113.761V0Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.435 92.513H113.761V139.86H137.435V92.513Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.54 44.9896H162.866V163.568H186.54V44.9896Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.096 42.6165C327.047 42.6165 317.105 45.3876 308.271 50.9147C304.16 53.7624 301.08 56.5336 299.032 59.2129H297.848C296.113 56.5259 293.737 53.7624 290.741 50.9147C283.955 45.38 275.664 42.6165 265.883 42.6165C258.15 42.6165 250.653 44.9896 243.394 49.7358C240.077 51.9481 237.319 54.3212 235.11 56.8475H233.926L231.557 44.9972H210.252V163.576H233.926V88.8691C233.926 81.7498 236.447 75.8247 241.499 71.0861C246.55 66.3475 252.701 63.9668 259.961 63.9668C267.22 63.9668 272.783 66.2251 277.124 70.7263C281.464 75.2352 283.635 81.2828 283.635 88.8691V163.576H307.308V88.8691C307.308 81.7498 309.83 75.8247 314.881 71.0861C319.932 66.3475 326.084 63.9668 333.343 63.9668C340.603 63.9668 346.166 66.2251 350.506 70.7263C354.847 75.2352 357.017 81.2828 357.017 88.8691V163.576H380.691V88.6318C380.691 75.1969 376.664 64.1735 368.617 55.5461C360.563 46.934 350.384 42.6241 338.074 42.6241L338.096 42.6165Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.115 44.9896H404.441V163.568H428.115V44.9896Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.141 44.9896L582.369 135.106H577.631L543.304 44.9896H518.446L566.978 171.867L563.196 182.538C562.722 184.276 561.774 185.899 560.353 187.399C558.932 188.899 557.197 189.657 555.149 189.657H531.475V211H556.334C564.862 211 571.281 209.377 575.629 206.139C579.969 202.901 583.4 197.795 585.93 190.844L638.015 44.9972H613.157L613.141 44.9896Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_298_1527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M633.297 8.36425C633.297 7.55641 632.973 6.91014 632.004 6.63672C632.886 6.26387 633.334 5.66731 633.334 4.85947C633.334 3.3805 632.203 2.7218 630.426 2.7218H627.828V10.0918H629.195V7.1587H630.649C631.594 7.1587 631.929 7.56884 631.942 8.37668V8.86138C631.942 9.10995 631.942 9.81836 632.079 10.0918H633.483V9.9675C633.371 9.68165 633.321 9.25909 633.321 8.86138V8.37668L633.297 8.36425ZM630.786 5.97802H629.195V3.85278H630.426C631.569 3.85278 631.979 4.13863 631.992 4.9589C631.992 5.60517 631.42 5.96559 630.786 5.96559V5.97802Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.5 0C626.921 0 624 2.83365 624 6.48757C624 10.1663 626.921 13 630.5 13C634.079 13 636.988 10.1663 637 6.48757C637 2.82122 634.092 0 630.5 0ZM630.5 11.9187C627.53 11.9187 625.119 9.56979 625.119 6.48757C625.119 3.43021 627.53 1.08126 630.5 1.08126C633.47 1.08126 635.869 3.43021 635.881 6.48757C635.881 9.56979 633.483 11.9187 630.5 11.9187Z",
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M475.516 67.4958H451.842V163.576H475.516V67.4958Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.941 7.14231C454.203 11.8885 451.842 18.9543 451.842 26.0659V44.9896H475.516V29.6179C475.516 24.8717 477.885 22.4986 482.622 22.4986H506.495V0.0229797H476.7C469.601 0.0229797 463.679 2.39609 458.949 7.14231H458.941Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.176 0.0229797H404.38V22.5063H428.176V0.0229797Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.601 0.0229797H162.805V22.5063H186.601V0.0229797Z",
    fill: "#161616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.638 67.4958H506.487V44.9896H475.516V67.4958H475.638Z",
    fill: "#161616"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_298_1527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 638,
    height: 211,
    fill: "#161616"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_298_1527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "#161616",
    transform: "translate(624)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBimifyDark);
export default __webpack_public_path__ + "static/media/logo-bimify-dark.6b2e860ccd4c6adb7af68012e3da97b1.svg";
export { ForwardRef as ReactComponent };